var _defs, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProcessPayment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.a{stroke:#000;stroke-width:0.75px;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-63 -432)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(65 434)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 6,
    cy: 6,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 6,
    cy: 6,
    r: 5.625
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.139,9.549a1.349,1.349,0,0,0-.122-.282.968.968,0,0,0-.2-.236,2.364,2.364,0,0,0-.229-.183,2.287,2.287,0,0,0-.282-.16l-.282-.13-.3-.122-.282-.114-.229-.1a1.319,1.319,0,0,1-.206-.114l-.145-.122a.419.419,0,0,1-.107-.152.5.5,0,0,1,.191-.595.968.968,0,0,1,.579-.16,1.243,1.243,0,0,1,.32.046,1.67,1.67,0,0,1,.274.1l.221.122.145.1.053.046a.122.122,0,0,0,.1,0,.1.1,0,0,0,.084-.061l.3-.541a.107.107,0,0,0,0-.145l-.053-.038L12.827,6.6a1.8,1.8,0,0,0-.236-.137,2.394,2.394,0,0,0-.328-.122,2.066,2.066,0,0,0-.412-.084V5.592a.114.114,0,0,0-.107-.122h-.511a.122.122,0,0,0-.122.122v.671a1.708,1.708,0,0,0-.953.5,1.273,1.273,0,0,0-.366.9,1.3,1.3,0,0,0,0,.29,1.525,1.525,0,0,0,.076.252A.915.915,0,0,0,10,8.42l.16.183a1.319,1.319,0,0,0,.2.16l.213.13.236.114.229.1.229.091.3.122.244.122a1.022,1.022,0,0,1,.221.137.7.7,0,0,1,.122.16.381.381,0,0,1,.053.2.518.518,0,0,1-.229.457.907.907,0,0,1-.534.16,1.3,1.3,0,0,1-.274,0,1.952,1.952,0,0,1-.907-.465h0a.091.091,0,0,0-.091,0,.114.114,0,0,0-.084.046l-.381.5a.114.114,0,0,0,0,.152l.069.069L9.945,11a2.287,2.287,0,0,0,.656.343,2.356,2.356,0,0,0,.473.114v.656a.122.122,0,0,0,.122.122h.511a.114.114,0,0,0,.122-.107h0v-.648a1.6,1.6,0,0,0,.961-.511,1.418,1.418,0,0,0,.374-.983,1.227,1.227,0,0,0-.023-.435Z",
    transform: "translate(59.604 431.03)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 16,
    height: 16
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProcessPayment);
export default __webpack_public_path__ + "static/media/Icon_Process_Payment.3d1f08324a904a61b4cdcdbea71efbb7.svg";
export { ForwardRef as ReactComponent };